module.exports = __webpack_public_path__ + "static/assets/633ccc492fe0cc1d4f37699c4526e257.svg";